import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCallingV2Service, API_CONFIG } from '@zayan-erp/shared';
import {
  SalesListingRequest,
  SalesListingResponse,
  ReportFilterRequest,
  ConstructionReleaseReportData
} from '../models/sales-reports.models';

@Injectable({
  providedIn: 'root'
})
export class SalesReportsService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getSalesListingReport(req: SalesListingRequest): Observable<SalesListingResponse> {
    return this.#http.postData<SalesListingResponse>(
      `${this.baseUrl}/sales-report/listing`,
      { showLoader: true, showMessage: false },
      req
    );
  }

  downloadSalesListingReportPdf(req: SalesListingRequest): Observable<void> {
    const filename = `sales_listing_${+new Date()}.pdf`;
    return this.#http.downloadReportFileWithBody(
      `${this.baseUrl}/sales-report/listing/export/pdf`,
      req,
      { showLoader: true, showMessage: true },
      filename
    );
  }
  downloadSalesListingReportExcel(req: SalesListingRequest): Observable<void> {
    const filename = `sales_listing_${+new Date()}.xlsx`;
    return this.#http.downloadReportFileWithBody(
      `${this.baseUrl}/sales-report/listing/export/excel`,
      req,
      { showLoader: true, showMessage: true },
      filename
    );
  }

  getConstructionReleaseReport(req: ReportFilterRequest): Observable<ConstructionReleaseReportData> {
    return this.#http.postData<ConstructionReleaseReportData>(
      `${this.baseUrl}/dsm-reports/construction-release`,
      { showLoader: false, showMessage: false },
      req
    );
  }

  downloadConstructionReleaseReportPdf(req: ReportFilterRequest): Observable<void> {
    const filename = `construction_release_${+new Date()}.pdf`;
    return this.#http.downloadReportFileWithBody(
      `${this.baseUrl}/dsm-reports/construction-release/pdf`,
      req,
      { showLoader: true, buttonId: 'construction-release-pdf', showMessage: true },
      filename
    );
  }

  downloadConstructionReleaseReportExcel(req: ReportFilterRequest): Observable<void> {
    const filename = `construction_release_${+new Date()}.xlsx`;
    return this.#http.downloadReportFileWithBody(
      `${this.baseUrl}/dsm-reports/construction-release/excel`,
      req,
      { showLoader: true, buttonId: 'construction-release-excel', showMessage: true },
      filename
    );
  }
}
